import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { network } from 'services/network';
import { useMutation } from 'react-query';

const extractDelayedActivitiesCsv = (params: ExtractDelayedActivitiesCsv) => {
    return network
        .post('api/bo/extractDelayedActivitiesCsv', params)
        .then((response) => {
            const blob = new Blob([response.data], {
                type: 'text/plain',
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${params.fileName}.csv`;
            a.click();

            return true;
        })
        .catch((error) => {
            throw error;
        });
};
const useMutationExtractDelayedActivitiesCsv = () => {
    return useMutation<unknown, QueryError, ExtractDelayedActivitiesCsv>((params) =>
        extractDelayedActivitiesCsv(params),
    );
};

interface ExtractDelayedActivitiesCsv {
    compareVersionId?: number;
    id: number[] | null;
    filter: { filters: IFilter[] };
    fileName: string;
}

export { useMutationExtractDelayedActivitiesCsv };
